import { ICrudLocale } from '@app/i18n/interface';

export const CUSTOMER_MANAGEMENT_LOCALE_ES: ICrudLocale = {
  CUSTOMER: {
    LABEL: {
      SINGULAR: 'Cliente',
      PLURAL: 'Clientes',
    },
    FIELD: {
      NAME: 'Nombre',
      CUSTOMER: 'Cliente',
      EMAIL: 'Correo',
      EMAIL_VERIFIED: 'Verificación',
      ENABLED: 'Acceso',
      MOBILE: 'Teléfono',
      GENDER: 'Género',
      CREATED_AT: 'Registrado',
      LAST_LOGIN: 'Último acceso',
    },
    LIST: {
      TITLE: 'Todos los clientes',
      DESCRIPTION:
        'Personas con cuenta en la web. Un cliente sin verificar todavía no ha confirmado su correo. El equipo del back office está en Usuarios.',
      FILTERS: 'Filtros',
      FILTERS_ARIA: 'Filtrar clientes',
      SEARCH: 'Buscar',
      SEARCH_PLACEHOLDER: 'Nombre o correo electrónico',
      SEARCH_HINT: 'Para buscar por correo, escríbelo con la @.',
      STATE_ALL: 'Todos los clientes',
      STATE_ACTIVE: 'Con acceso',
      STATE_INACTIVE: 'Desactivados',
      APPLY: 'Aplicar filtros',
      CLEAR: 'Limpiar',
      CAPTION: 'Clientes registrados en la web',
      NEVER: 'Nunca',
      VIEW_ARIA: 'Ver la ficha de {{name}}',
      NO_NAME: 'Sin nombre',
      EMPTY: 'Todavía no hay clientes registrados. Aquí aparece quien se da de alta en la web; al equipo se le gestiona en Usuarios.',
    },
    VERIFIED: {
      YES: 'Verificado',
      NO: 'Sin verificar',
    },
    ENABLED_STATE: {
      ACTIVE: 'Con acceso',
      INACTIVE: 'Desactivado',
    },
    DETAIL: {
      TITLE: 'Detalle del cliente',
      SUMMARY: 'Datos del cliente',
      BACK: 'Volver a Clientes',
      NOT_FOUND: 'No se encontró el cliente solicitado.',
    },
    BOOKINGS: {
      TITLE: 'Reservas del cliente',
      DESCRIPTION: 'Reservas hechas por este cliente.',
      EMPTY: 'Este cliente no tiene reservas.',
      VIEW: 'Ver reserva',
      VIEW_ARIA: 'Ver la reserva {{ref}}',
    },
  },
};
